import {match, Pattern} from 'ts-pattern';
import {z} from 'zod';

import i18n from '@dms/i18n';

interface RatePair {
  nominalRate: number | null;
  apr: number | null;
}

/**
 * The nominal rate and the APR are advertised as a pair: either both are empty, or both are filled
 * in — an offer must never show only one of them. The rule belongs to the object holding the pair,
 * so schemas apply it through `superRefine`; on an array of variants the issue path resolves to
 * the offending item on its own.
 */
export function addRatePairIssues(values: RatePair, context: z.RefinementCtx) {
  const addMissingRateIssue = (path: keyof RatePair) => {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      message: i18n.t('general.errors.mixed.required'),
      path: [path],
    });
  };

  match(values)
    .with({nominalRate: Pattern.number, apr: null}, () => addMissingRateIssue('apr'))
    .with({nominalRate: null, apr: Pattern.number}, () => addMissingRateIssue('nominalRate'))
    .otherwise(() => undefined);
}
